import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) { }

  getCountries() {
    return this.http.get(`${environment.ADMIN_BASE_URL}/countries`).pipe(retry(3));
  }

  setNewPassword(payload) {
    return this.http
      .put(`${environment.API_URL}/merchant/user/updatepassword`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('resetToken')}`
        }
      })
      .pipe(retry(3));
  }

  fetchAuthUser() {
    return this.http.get(`${environment.ADMIN_BASE_URL}/auth/user`).pipe(retry(3));
  }

  fetchEntityTypes = (country_code) => {
    let params = new HttpParams();
    params = params.append('country_code', country_code);
    return this.http.get(`${environment.API_URL2}/transactions-service/ent`, { params });
  };

  fetchBusinessTypes = () => this.http.get(`${environment.API_URL}/business/type`).pipe(retry(3));

  runKyc = (payload: any): Observable<any> => this.http.post(`${environment.API_URL2}/user-service/verification/image-kyc`, payload);

  fetchTransactionTypes = () => this.http.get(`${environment.API_URL}/business/transactions/type`).pipe(retry(3));

  createMerchant = (requestBody) => this.http.post(`${environment.API_URL}/merchants`, requestBody);

  updateUtilityMerchant = (requestBody, id): Observable<any> =>
    this.http.put(`${environment.API_URL2}/transactions-service/merchant/${id}`, requestBody).pipe(retry(3));

  getCompanyProfile = (companyNumber) =>
    this.http.get(
      `${environment.API_URL2}/user-service/business/company-profile?companyNumber=${companyNumber}&countryCode=GB`
    );

  requestPasswordRequest = (payload) => this.http.post(`${environment.API_URL2}/xas/v1/merchant/accounts/password/reset-request`, payload).pipe(retry(2))
  resetPassword = (payload) => this.http.post(`${environment.API_URL2}/xas/v1/merchant/accounts/password/reset`, payload).pipe(retry(2))

  // Login entry point: validates credentials and triggers the email OTP.
  // Returns { data: { sessionId, expiresIn } }; the MFA flow continues from there.
  login = (email: string, password: string) =>
    this.http.post(`${environment.API_URL2}/asa/users/login`, { email, password })

  resendOtp = (sessionId: string) =>
    this.http.post(`${environment.API_URL2}/asa/users/resend-otp`, { sessionId })

  verifyMfa = (sessionId: string, otpCode: string) =>
    this.http.post(`${environment.API_URL2}/asa/users/verify-otp`, { sessionId, otpCode })
}